import * as actionTypes from './TagsActions';
import axios from 'axios';
import store from '../../../index';
import { backend_server_address } from '../../../backendServer';
import { Dispatch } from 'redux';
import {
    GetTagNodesFailAction,
    GetTagNodesStartAction,
    GetTagNodesSuccessAction,
    TagNodesActionTypes,
    TagNodesResponse,
} from './tagsTypes';

export const getTagNodesStart = (): GetTagNodesStartAction => {
    return {
        type: actionTypes.GET_TAG_NODES_START,
    };
};

export const getTagNodesSuccess = (tag_nodes: TagNodesResponse, tag: any): GetTagNodesSuccessAction => {
    return {
        type: actionTypes.GET_TAG_NODES_SUCCESS,
        tag_nodes: Array.isArray(tag_nodes['node_tags'])
            ? { [Array.isArray(tag) ? tag[0] : tag]: tag_nodes['node_tags'], ...store.getState().tagsReducer.tag_nodes }
            : { ...tag_nodes['node_tags'], ...store.getState().tagsReducer.tag_nodes },
    };
};

export const getTagNodesFail = (error: Error): GetTagNodesFailAction => {
    return {
        type: actionTypes.GET_TAG_NODES_FAIL,
        error: error,
    };
};

export const getTagNodes = (tag: any) => {
    return (dispatch: Dispatch<TagNodesActionTypes>) => {
        dispatch(getTagNodesStart());
        let data = {
            name: tag,
        };
        axios
            .get(backend_server_address + '/api/tag/node_tags/', {
                withCredentials: true,
                params: data,
            })
            .then((res) => {
                dispatch(getTagNodesSuccess(res.data, tag));
            })
            .catch((error) => {
                dispatch(getTagNodesFail(error));
            });
    };
};
